// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__10ZW4","fileDisabled":"File_fileDisabled__1BFAi"};